import React, { useState } from 'react';
import styles from '../styles/User.module.scss';

const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 1l22 22" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PasswordField = ({
  name,
  value,
  onChange,
  placeholder,
  autoComplete,
  required = false,
  id,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={styles.passwordWrap}>
      <input
        type={visible ? 'text' : 'password'}
        placeholder={placeholder}
        name={name}
        id={id}
        value={value}
        autoComplete={autoComplete}
        onChange={onChange}
        required={required}
        className={styles.passwordInput}
      />
      <button
        type="button"
        className={styles.passwordToggle}
        onClick={() => setVisible((prev) => !prev)}
        aria-label={visible ? 'Приховати пароль' : 'Показати пароль'}
        aria-pressed={visible}
      >
        {visible ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </div>
  );
};

export default PasswordField;
